import { render, staticRenderFns } from "./WorkshopsVideos.vue?vue&type=template&id=4d281b16&scoped=true&"
import script from "./WorkshopsVideos.vue?vue&type=script&lang=js&"
export * from "./WorkshopsVideos.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsVideos.vue?vue&type=style&index=0&id=4d281b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d281b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
